import { PlayerUserDetailSkeleton } from "components/Skeleton/PlayerUsersPage/PlayerUserDetailSkeleton";
import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import client from "libs/client";
import { useEffect } from "react";
import { useParams } from "react-router";
import SkeletonBox from "ui-kit/src/Skeleton/SkeletonBox";
import NotFoundPage from "./errorPages/NotFoundPage";
import { DiscoverSignUpGetResponse } from "libs/apiClient";
import {DiscoverBreadcrumbs} from "features/discover/DiscoverBreadcrumbs";
import {DiscoverSignUpDetail} from "features/discover/DiscoverSignUpDetail";

export function DiscoverSignUpPage() {
    const { id } = useParams();

    useEffect(() => { setScrollBehavior() }, [])

    const { data: response, isLoading, error } = client.getDiscoverSignUp.useQuery({ id: parseInt(id || "") }, { queryKey: ["discoverSignUpDetail"] })

    if (error) {
        const code = error?.response.status;

        if (code === 404) {
            return (
                <div>
                    <NotFoundPage />
                </div>
            );
        }
    }

	const data: DiscoverSignUpGetResponse = response?.data || {} as DiscoverSignUpGetResponse

	return (
        <div className="discover-container">
            <div className="pageHeading">
				{isLoading
					? <SkeletonBox style={{ width: "300px", height: "32px", margin: "35px 0 35px 0" }} />
					: <DiscoverBreadcrumbs items={[
						{
							label: 'Sign-up(s)',
							route: '/discover/sign-up'
						},
						{
							label: `${data.firstName} ${data.lastName}`,
							note: data.id,
						},
					]} />
				}

			</div>
			{isLoading
				? <PlayerUserDetailSkeleton/>
				: <DiscoverSignUpDetail signUpData={data} />}
        </div>
    )
}
